// src/js/main.js
import '../scss/main.scss';
import { initMapSync } from './modules/mapSync.js';
import { MapComponent } from './map/index.js';
import { UIController } from './modules/uiController.js';
import { TimelineController } from './modules/timelineController.js';
import { HotspotTooltips } from './modules/hotspotTooltips.js';

// import { initWordPressMenu } from './modules/wpMenu.js'; // Future module example

window.addEventListener('load', () => {
  const pano = window.pano;

  if (!pano) {
    console.error("Pano2VR engine not found.");
    return;
  }

  console.log("Tour loaded, booting modules...");

  // Initialize your separated modules and pass the Pano2VR instance to them
  initMapSync(pano);
  
  // Initialize unified map overlay
  const mapOverlay = new MapComponent(pano);
  mapOverlay.init();
  
  // Expose it globally so Pano2VR skin elements can communicate with it
  window.mapOverlay = mapOverlay;

  // Initialize Glassmorphism Main UI Overlays
  const mainUI = new UIController(pano);
  mainUI.init();
  window.mainUI = mainUI;

  // Initialize Timeline UI
  const timelineController = new TimelineController(pano);
  timelineController.init();
  window.timelineController = timelineController;

  // One hotspot label at a time: nearest the view centre, or whatever is hovered.
  const hotspotTooltips = new HotspotTooltips(pano);
  hotspotTooltips.init();
  window.hotspotTooltips = hotspotTooltips;

});